var _rect, _path, _path2, _g, _path3, _g2, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurrencyAud(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1516_136727)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1516_136727)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -9.00391,
    y: -1,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1183 -1H-9.00391V29.6785H37.1183V-1Z",
    fill: "#012169"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1516_136727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -10,
    y: -1,
    width: 25,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 -1H14.0572V14.3393H-9.00391V-1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1516_136727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 -1L14.0572 14.3393ZM14.0572 -1L-9.00391 14.3393Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 -1L14.0572 14.3393M14.0572 -1L-9.00391 14.3393",
    stroke: "white",
    strokeWidth: 3.06785
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1516_136727",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -10,
    y: -1,
    width: 25,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 -1V6.66964H14.0572V14.3393L-9.00391 -1ZM14.0572 -1H2.52663V14.3393H-9.00391L14.0572 -1Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1516_136727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 -1L14.0572 14.3393ZM14.0572 -1L-9.00391 14.3393Z",
    fill: "#000008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.00391 -1L14.0572 14.3393M14.0572 -1L-9.00391 14.3393",
    stroke: "#E4002B",
    strokeWidth: 2.04524
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52663 -1V14.3393ZM-9.00391 6.66964H14.0572Z",
    fill: "#000008"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52663 -1V14.3393M-9.00391 6.66964H14.0572",
    stroke: "white",
    strokeWidth: 5.11309
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52663 -1V14.3393ZM-9.00391 6.66964H14.0572Z",
    fill: "#000008"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.52663 -1V14.3393M-9.00391 6.66964H14.0572",
    stroke: "#E4002B",
    strokeWidth: 3.06785
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.252944 16.9131L1.00222 19.2427L3.29076 18.376L1.93654 20.4143L4.04104 21.6632L1.60309 21.8753L1.93881 24.2993L0.252944 22.5255L-1.43292 24.2993L-1.0972 21.8753L-3.53516 21.6632L-1.43066 20.4143L-2.78488 18.376L-0.496328 19.2427L0.252944 16.9131Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1554 21.1069L26.5122 22.2163L27.602 21.8036L26.9571 22.7742L27.9593 23.3689L26.7983 23.4699L26.9582 24.6242L26.1554 23.7795L25.3526 24.6242L25.5125 23.4699L24.3516 23.3689L25.3537 22.7742L24.7088 21.8036L25.7986 22.2163L26.1554 21.1069Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6828 10.8535L20.0396 11.9629L21.1293 11.5502L20.4845 12.5208L21.4866 13.1155L20.3257 13.2165L20.4856 14.3708L19.6828 13.5261L18.88 14.3708L19.0398 13.2165L17.8789 13.1155L18.881 12.5208L18.2362 11.5502L19.326 11.9629L19.6828 10.8535Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1554 3.83789L26.5122 4.94724L27.602 4.53453L26.9571 5.50515L27.9593 6.09986L26.7983 6.20085L26.9582 7.35515L26.1554 6.51047L25.3526 7.35515L25.5125 6.20085L24.3516 6.09986L25.3537 5.50515L24.7088 4.53453L25.7986 4.94724L26.1554 3.83789Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7452 14.3228L29.0272 15.014L29.7717 15.0685L29.2015 15.5503L29.3796 16.2752L28.7452 15.8818L28.1108 16.2752L28.289 15.5503L27.7188 15.0685L28.4633 15.014L28.7452 14.3228Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1516_136727"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1516_136727"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -9.00391,
    y: -1,
    width: 46.1222,
    height: 30.6785,
    rx: 5.76455,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrencyAud);
export default __webpack_public_path__ + "static/media/Currency=AUD.c7922528853905e9ce73bff9a20a6801.svg";
export { ForwardRef as ReactComponent };